export default "__VITE_ASSET__4Zq$cUxF__"